import React from 'react'
import CompanyOverview from "../../component/AboutUs/CompanyOverview/CompanyOverview"
import Timeline from '../../component/AboutUs/MissionVisionGoals/Timeline'
import OurTeam from '../../component/AboutUs/OurTeams/OurTeam'
import OfferSection from '../../component/AboutUs/WhatWeOffer/OfferSection'
import LeaderShipTeam from '../../component/AboutUs/LeaderShipTeam/LeaderShipTeam'
import FeaturesSection from '../../component/AboutUs/WhyNextech/FeaturesSection'
import AboutUsBanner from '../../component/AboutUs/AboutUsBanner/AboutUsBanner'
import { ToastContainer } from 'react-toastify'
import ContactForm from '../../component/ContactUs/ContactUsForm/ContactForm'
import 'react-toastify/dist/ReactToastify.css';
import FloatingContactUs from '../../component/floting_contact/FloatingContactUs'


const AboutUsPage = () => {
  return (
    
    <>

         
    

    <ToastContainer />
    <AboutUsBanner />
    <FloatingContactUs />
    <CompanyOverview />
    <OfferSection />
    <Timeline />
    <FeaturesSection/>
    <OurTeam />
   <LeaderShipTeam />
   <ContactForm />
    </>
  )
}

export default AboutUsPage